import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import TableHead from '@mui/material/TableHead';
import {
    Typography, Stepper, Step, StepLabel, Box, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, Paper, InputAdornment, Button
} from "@mui/material";
import moment from 'moment';

const BokingCModal = ({ OpenHistoryTableDialog, handleClose, columns, TextField, handleSearchChange, filteredRows, page, rowsPerPage, handleBookNoChange, handleMobileChange, handleChangePage, handleChangeRowsPerPage }) => {
    return (
        <Dialog open={OpenHistoryTableDialog} onClose={handleClose} maxWidth="lg" fullWidth>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                px={3}
                pt={1}
            >
                <DialogTitle sx={{ m: 0, p: 0 }}>Booking Details</DialogTitle>
                <DialogActions sx={{ m: 0, p: 0 }}>
                    <Button onClick={handleClose} color="error">
                        Close
                    </Button>
                </DialogActions>
            </Box>
            <DialogContent>
                <Paper sx={{ width: '100%', overflow: 'hidden', margin: '0px 0px 0px 0px', border: '1px solid lightgray' }}>
                    <TableContainer sx={{ maxHeight: 300 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow
                                    sx={{
                                        '& > th': {
                                            padding: '2px  10px 2px  10px'
                                        }
                                    }}
                                >
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                {column.label}
                                            </Typography>
                                            <TextField
                                                size="small"
                                                variant="outlined"
                                                placeholder={`Search ${column.label}`}
                                                onChange={(e) => handleSearchChange(column.id, e.target.value)}
                                                sx={{
                                                    mt: 1, margin: '0px', '& .MuiOutlinedInput-input': {
                                                        padding: '2px 6px',
                                                    },
                                                }}
                                            />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredRows
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        // Create a unique key
                                        // const uniqueKey = `${row.RoomId}-${row.RoombedName}`;
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={index}
                                                // onDoubleClick={() => handleMobileChange(row.MobileNo,"B")}
                                                onDoubleClick={() => handleBookNoChange(row.BookNo, "B")}
                                                style={{ cursor: 'pointer' }}
                                                sx={{
                                                    '& > td': {
                                                        padding: '2px 14px 2px 19px',
                                                    }
                                                }}
                                            >
                                                {columns.map((column) => {
                                                    const value = row[column.id];
                                                    return (
                                                        <TableCell key={column.id} align={column.align}>
                                                            {(column.id === "BookDt" || column.id === "CheckinDt" || column.id === "CheckoutDt") ? moment(value).format("DD-MM-YYYY") : value}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 15, 100]}
                        component="div"
                        count={filteredRows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </DialogContent>
        </Dialog>
    )
}

export default BokingCModal
